import { FadeIn } from './components';

export const AnimatedViews = {
  FadeIn,
};
